import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation_price_data } from '@shared/dto/generation_price/DTO__generation_price_data';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateGenerationPrice } from './state_generation_price';

export const local_generation_price_upsert_generation_price_by_hash = (payload: DTO__generation_price_data[]): PayloadAction<DTO__generation_price_data[]> => ({
  type: ENUM__redux_action.GENERATION_PRICE_UPSERT_GENERATION_PRICE_BY_HASH,
  payload,
});

export const init_local_generation_price_upsert_generation_price_by_hash = (
  state: StateGenerationPrice,
  action: PayloadAction<DTO__generation_price_data[]>,
) => {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let generation_price_data of items) {
    state.generation_prices_by_hash_loading_in_progress_set.delete(generation_price_data.hash);

    state.generation_prices_by_hashes_map.set(generation_price_data.hash, generation_price_data);
  }

  //refresh map to trigger re-render
  state.generation_prices_by_hash_loading_in_progress_set = new Set(state.generation_prices_by_hash_loading_in_progress_set);

  //refresh map to trigger re-render
  state.generation_prices_by_hashes_map = new Map(state.generation_prices_by_hashes_map);
};
